import {useCallback, useState} from 'react';

const useContentElementRef = () => {
  const [contentElementRef, setElementRef] = useState(null);

  const setContentElementRef = useCallback(node => {
    const elementRef = node && node.getContentElementRef?.();
    if (elementRef && elementRef !== contentElementRef) {
      setElementRef(elementRef);
    }
  }, [contentElementRef]);

  return {
    contentElementRef,
    setContentElementRef
  };
};
export default useContentElementRef;
